import { Teksten } from "../../../content";
import { Geldigheid } from "../../../models/document-metadata";
import { useAppDispatch } from "../../../store/hooks";
import { FormState, updateZichtbaarheidDate, updateZichtbaarheidTime } from "../../../store/reducers/document-metadata";
import { formatDate, stringToDate, timeFormatter } from "../../../utils/DateFormatter";
import { CheckboxAtom, ContainerAtom, SpacerAtom } from "../../atoms";
import { DateInputMolecule, TimeInputMolecule } from "../text-input";
import { TooltipMolecule } from "../tooltip";

interface Props {
  uitgesteldPubliceren: boolean;
  disabled: boolean;
  formState: FormState;
  geldigheid?: Geldigheid;
  fcd: {
    setUitgesteldPubliceren: React.Dispatch<React.SetStateAction<boolean>>;
    setConcept: React.Dispatch<React.SetStateAction<boolean>>;
    setCurrentPublishTime: React.Dispatch<React.SetStateAction<string>>;
    setCurrentPublishDate: React.Dispatch<React.SetStateAction<Date>>;
    uitgesteldPubliceren: boolean;
    currentPublishDate: Date;
    currentPublishTime: string;
  };
}

export function UitgesteldPublicerenToggleMolecule(props: Readonly<Props>) {
  const dispatch = useAppDispatch();

  const uitgesteldPublicerenToggle = () => {
    props.fcd.setUitgesteldPubliceren(!props.fcd.uitgesteldPubliceren);
    props.fcd.setConcept(false);

    if (props.fcd.uitgesteldPubliceren) {
      dispatch(updateZichtbaarheidDate(undefined));
    } else {
      let date = new Date();
      date.setMinutes(date.getMinutes() + 15);
      dispatch(updateZichtbaarheidDate(date.toJSON()));
      dispatch(updateZichtbaarheidTime(date.toTimeString()));
    }
  };

  return (
    <>
      <div style={{ display: "flex", alignItems: "center" }}>
        <CheckboxAtom
          disabled={props.disabled}
          id={Teksten.createScreen.uitgesteld.id}
          checked={props.uitgesteldPubliceren}
          onClick={uitgesteldPublicerenToggle}
          label={Teksten.createScreen.uitgesteld.label}
        />
        <TooltipMolecule
          id={Teksten.createScreen.uitgesteld_tooltip.id}
          content={Teksten.createScreen.uitgesteld_tooltip.tooltip}
        />
      </div>

      {props.uitgesteldPubliceren && (
        <>
          <SpacerAtom space={4} />
          <ContainerAtom type="row">
            <DateInputMolecule
              disabled={props.disabled}
              key={Teksten.createScreen.uitsteldatum.id}
              id={Teksten.createScreen.uitsteldatum.id}
              placeholder={Teksten.createScreen.uitsteldatum.placeholder}
              defaultValue={formatDate(props.fcd.currentPublishDate)}
              onChange={(date: string) => {
                props.fcd.setCurrentPublishDate(new Date(date));
              }}
              onBlur={(date: React.ChangeEvent<HTMLInputElement>) => {
                props.fcd.setCurrentPublishDate(new Date(date.currentTarget.value));
                dispatch(updateZichtbaarheidDate(date.currentTarget.value));
                if (date.currentTarget.value === "" || new Date(date.currentTarget.value) < new Date())
                  date.currentTarget.value = formatDate(new Date());
              }}
            />
            <TimeInputMolecule
              disabled={props.disabled}
              minDate={props.geldigheid?.begindatum ? stringToDate(props.geldigheid?.begindatum) : undefined}
              key={Teksten.createScreen.uitsteltijd.id}
              id={Teksten.createScreen.uitsteltijd.id}
              placeholder={Teksten.createScreen.uitsteltijd.placeholder}
              value={props.fcd.currentPublishTime}
              onChange={(time: string) => {
                props.fcd.setCurrentPublishTime(time);
              }}
              onBlur={(time: React.ChangeEvent<HTMLInputElement>) => {
                dispatch(updateZichtbaarheidTime(time.currentTarget.value));
                props.fcd.setCurrentPublishTime(
                  timeFormatter(
                    props.formState?.meta.document.zichtbaarheidsdatumtijd
                      ? stringToDate(props.formState?.meta.document.zichtbaarheidsdatumtijd)
                      : new Date()
                  )
                );
              }}
            />
          </ContainerAtom>
        </>
      )}
    </>
  );
}
